export const emails = {
  cl: 'contacto@pjchile.com',
  cr: 'servicioalcliente@pjcostarica.com',
  gt: 'servicioalcliente@pjguatemala.com',
  pa: 'atencion@pjpanama.com',
  es: 'atencionalcliente@pjespana.es',
  pt: 'info@papajohns.pt'
};

export const phones = {
  cr: '+506 2258-9999',
  gt: '+502 2500-0000',
  pa: '+507 271-0000',
  cl: '+56 600 390 5000',
  es: '+34 900 900 532',
  pt: '+351 211 145 453'
};

export const currencies = {
  gt: 'GTQ',
  pa: 'USD',
  cr: 'CRC',
  cl: 'CLP',
  es: 'EUR',
  pt: 'EUR'
};
